import React, { Component } from 'react';
import { Tabs } from 'antd';
import List from './List';

const { TabPane } = Tabs;

class TablePage extends Component {
    constructor(props) {
        super(props);
        this.panes = [{
            title: '进行中项目',
            key: '1',
            content: this.getContent,
        }, {
            title: '已结束项目',
            key: '0',
            content: this.getContent,
        }];
    }

    getContent = (key) => {
        const { activeKey } = this.props;
        if (key === activeKey) {
            return (
                <List
                    activeKey={activeKey}
                    {...this.props}
                />
            );
        }
    }

    render() {
        const { activeKey, handleTabsChange } = this.props;

        return (
            <Tabs type="card" activeKey={activeKey} onChange={handleTabsChange}>
                {this.panes.map(pane => <TabPane tab={pane.title} key={pane.key}>{pane.content(pane.key)}</TabPane>)}
            </Tabs>
        );
    }
}

export default TablePage;


// WEBPACK FOOTER //
// ./src/components/investigation/Simple/index.js